var Handlebars = require('/home/circleci/project/node_modules/handlebars/lib/index.js');
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(depth0,helpers,partials,data) {
  var stack1, helperMissing=helpers.helperMissing, buffer = "";
  stack1 = ((helpers.neq || (depth0 && depth0.neq) || helperMissing).call(depth0, ((stack1 = (depth0 != null ? depth0.event : depth0)) != null ? stack1['attending-staus'] : stack1), "rsvp", {"name":"neq","hash":{},"fn":this.program(2, data),"inverse":this.program(4, data),"data":data}));
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"2":function(depth0,helpers,partials,data) {
  return "            Joining the community is required\n";
  },"4":function(depth0,helpers,partials,data) {
  return "            No Polls, <b>yet</b></h1>\n";
  },"6":function(depth0,helpers,partials,data) {
  return "    No Polls, <b>yet</b>\n";
  },"8":function(depth0,helpers,partials,data) {
  return "inApp";
  },"10":function(depth0,helpers,partials,data) {
  return "mobile-view ";
  },"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, buffer = "<h1 class=\"mobile-polls-empty-state-text\">\n";
  stack1 = ((helpers.eq || (depth0 && depth0.eq) || helperMissing).call(depth0, ((stack1 = (depth0 != null ? depth0.event : depth0)) != null ? stack1.privacy : stack1), "private-community", {"name":"eq","hash":{},"fn":this.program(1, data),"inverse":this.program(6, data),"data":data}));
  if (stack1 != null) { buffer += stack1; }
  buffer += "</h1>\n\n\n<img class=\"mobile-polls-list-empty-state-img ";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.inApp : depth0), {"name":"if","hash":{},"fn":this.program(8, data),"inverse":this.program(10, data),"data":data});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "\" src=\""
    + escapeExpression(((helpers.cdn || (depth0 && depth0.cdn) || helperMissing).call(depth0, "/images/polls/NoPollsYet.png", {"name":"cdn","hash":{},"data":data})))
    + "\" />";
},"useData":true});